

















































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'
import dayjs from 'dayjs'

@Component
export default class Contacts extends Vue { 
    @Prop(String) readonly labelText: any
    @Prop(String) readonly dateFrom: any
    @Prop(String) readonly dateTo: any
	@Prop() public changeState: any
	@Prop() public notifcation: any
	
	
    menu = false

	monthText = ['มกราคม','กุมภาพันธ์', 'มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม']
	date = new Date().toISOString().substr(0, 10)
	modal = false
	dateFromTo = [] as any

	get dateRangeText() {
		if (this.dateFromTo.length > 1) {
			const [yearFrom, monthFrom, dayFrom] = this.dateFromTo[0].split("-")
			const [yearTo, monthTo, dayTo] = this.dateFromTo[1].split("-")
			return `${dayFrom}/${monthFrom}/${yearFrom} ~ ${dayTo}/${monthTo}/${yearTo}`
		}
				
		return []
	}

	set dateRangeText (newValue: any) {}

	setYear (date: string){
		return date.substring(0, 4)
	}
	
	setHeaderDate (date: string) {
		const splitDate: any[] = date.split("-")
		const myText = `${this.monthText[splitDate[1]-1] === undefined ? '' : this.monthText[splitDate[1]-1]} ${date.substring(0, 4)}`
		return myText
	}

	titleSelectedItem () {
		if (this.dateFromTo.length > 1) {
			const [yearFrom, monthFrom, dayFrom] = this.dateFromTo[0].split("-")
			const [yearTo, monthTo, dayTo] = this.dateFromTo[1].split("-")
			const date1 = dayjs(this.dateFromTo[1])
			const date2 = dayjs(this.dateFromTo[0])
			const nDate = date1.diff(date2, 'day')
			return `${dayFrom}/${monthFrom}/${yearFrom} ~ ${dayTo}/${monthTo}/${yearTo} (${nDate}) วัน`
		}
	}

	ok () {
		if (this.dateFromTo.length < 2) {
			this.notifcation(`กรุณาระบุวันที่เริ่มต้นกับสินสุดให้ครบ`, "warning")
			return
		}
		const date1 = dayjs(this.dateFromTo[1])
		const date2 = dayjs(this.dateFromTo[0])
		if (date1.diff(date2, 'day') < 0) {
			this.notifcation(`กรุณาเลือกวันที่เริ่มต้นน้อยกว่าวันที่สินสุด`, "warning")
			return
		}

		this.changeState(this.dateFrom, this.dateFromTo[0])
		this.changeState(this.dateTo, this.dateFromTo[1])
		this.modal = false
	}
	cancel () {
		this.changeState(this.dateFrom, "")
		this.changeState(this.dateTo, "")
		this.dateFromTo = []
		this.modal = false
	}
	clear () {
		this.changeState(this.dateFrom, "")
		this.changeState(this.dateTo, "")
		this.dateFromTo = []
	}

}
